import React, { Component } from 'react';

class MapMarker extends Component {

  render() {
    const markerStyle = {
      backgroundImage: `url(${this.props.icon})`,
      height: "38px",
      width: "31px",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: "bold",
      paddingBottom: "6px",
      paddingRight: "2.5px",
      boxSizing: "border-box",
      fontFamily: "pangram-regular"
    }

    return (
      <div style={markerStyle}>
        {this.props.position}
      </div>
    );
  }
}

export default MapMarker



// WEBPACK FOOTER //
// ./src/components/MapMarker.js